import jwtDecode from "jwt-decode";
import http from "./httpService";
import api from '../config.json';
import swal from 'sweetalert';

const apiEndpoint = api.api + "login";
const tokenKey = "token";


// consol('bhdvhsdh')
// consol(getJwt())
http.setJwt(getJwt());
//http.setDataRights(getDataRights())

// const errorFlag=http.setJwt(getJwt());
// if(errorFlag)
// logout()



export async function login(user, cb) {
  try {
    const jwt = await http.post(apiEndpoint, user, { headers: { Company: user.company } })
    cb(null, jwt)
  }
  catch (err) {
    cb(err, null)
  }


  // localStorage.setItem(tokenKey, jwt); 

}
export async function subscribe(email, subscription) {
  const subscribe = await http.post(api.api + 'subscribe', { email: email, subscription: subscription }).catch((err) => {
    // consol(err)
  });

  // localStorage.setItem(tokenKey, jwt); 
  return subscribe;
}
export async function userActiveStatus(email) {
  const status = await http.get(api.api1 + 'checkUserIsActive/' + email).catch((err) => {
    if (err) {
      console.log(err);
      return err
    }
  });

  // localStorage.setItem(tokenKey, jwt); 
  const cookieRow = document.cookie
    .split('; ')
    .find(row => row.startsWith('myCookie='));

  if (cookieRow) {
    const cookieValue = cookieRow.split('=')[1];
    console.log(cookieValue, "Cookie found");
    let status = [];
    status.data = true
    return status;
  } else {
    // If token is not found in localStorage or cookie, return null or handle accordingly
    console.log(status, "ufuyfuruy")
    return status;
  }
}

export function loginWithJwt(jwt) {
  localStorage.setItem(tokenKey, jwt);
}

export async function logout(email) {
  localStorage.removeItem(tokenKey);
  localStorage.removeItem('equipment');
  localStorage.removeItem('equipmentgroup');
  // Expire the cookie instantly for all subdomains
  // Get the current time
  const currentTime = new Date();

  // Expire the cookie instantly with the current time
  document.cookie = `myCookie=; expires=${currentTime.toUTCString()}; path=/; domain=leafnet.cc`;

  localStorage.clear();
  await http.get(api.api1 + 'logout/' + email)

}
export function checkTokenExpiration() {
  const jwt = localStorage.getItem(tokenKey);
  if (jwt !== null) {
    if (jwtDecode(jwt).exp < Date.now() / 1000) {

      localStorage.clear();
    }
  }

}

export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem(tokenKey);
    console.log(jwt, "token 1")
    if (jwt) {
      // If token is found in localStorage, return it
      http.setJwt(jwt);
      const user = jwtDecode(jwt);
      return jwtDecode(jwt);
    } else {

      // If token is not found in localStorage, try to get it from the cookie
      const cookieRow = document.cookie
        .split('; ')
        .find(row => row.startsWith('myCookie='));

      console.log(cookieRow, "token 2")
      if (cookieRow) {
        const cookieValue = cookieRow.split('=')[1];
        console.log(cookieValue, "Cookie found");
        http.setJwt(cookieValue);
        const user = jwtDecode(cookieValue);
        return jwtDecode(cookieValue);
      } else {
        // If token is not found in localStorage or cookie, return null or handle accordingly
        console.log('Token not found');
        return null;
      }
    }


  } catch (ex) {
    return null;
  }
}

export function getJwt() {
  // Attempt to get the token from localStorage
  const localStorageToken = localStorage.getItem(tokenKey);
  console.log(localStorageToken, "token 3")

  if (localStorageToken) {
    // If token is found in localStorage, return it
    return localStorageToken;
  } else {
    // If token is not found in localStorage, try to get it from the cookie
    const cookieRow = document.cookie
      .split('; ')
      .find(row => row.startsWith('myCookie='));
    console.log(cookieRow, "token 4")

    if (cookieRow) {
      const cookieValue = cookieRow.split('=')[1];
      console.log(cookieValue, "Cookie found");
      localStorage.setItem(tokenKey, cookieValue);

      return cookieValue;
    } else {
      // If token is not found in localStorage or cookie, return null or handle accordingly
      console.log('Token not found');
      return null;
    }
  }
}
// export function getDataRights() {
//   return ;
// }

export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt,
  checkTokenExpiration,
  subscribe,
  userActiveStatus
};
